export class AccessDeniedError extends Error {
    constructor(message) {
        super(message);
        this.name = "ACCESS_DENIED";
    }
}
